import { useEffect, useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { App } from 'antd'
import confetti from 'canvas-confetti'
import { ThemeContext } from '../context/themeContext'
import { DARK_THEME } from '@vacationtracker/shared/constants/ThemeSetting'

const LIGHT_COLORS = ['#7c3aed', '#a78bfa', '#ddd6fe', '#c4b5fd', '#818cf8', '#fbbf24', '#34d399']
const DARK_COLORS = ['#a78bfa', '#ddd6fe', '#ffffff', '#c4b5fd', '#818cf8', '#fbbf24', '#34d399']

const burst = (colors: string[]) => {
  confetti({
    particleCount: 80,
    startVelocity: 35,
    spread: 360,
    origin: { x: 0.5, y: 0.5 },
    colors,
    ticks: 200,
  })
}

const runFireworks = (isDark: boolean) => {
  const colors = isDark ? DARK_COLORS : LIGHT_COLORS
  burst(colors)
  setTimeout(() => burst(colors), 800)
  setTimeout(() => burst(colors), 1600)
}

export const useWizardCompletedConfetti = () => {
  const location = useLocation()
  const history = useHistory()
  const { notification } = App.useApp()
  const { formatMessage } = useIntl()
  const { theme } = useContext(ThemeContext)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.get('wizardCompleted') !== 'true') return

    params.delete('wizardCompleted')
    history.replace({ search: params.toString() })

    const isDark = theme === DARK_THEME
    runFireworks(isDark)

    notification.success({
      message: formatMessage({ id: 'onboarding.setup.completed.title' }),
      description: formatMessage({ id: 'onboarding.setup.completed.description' }),
      duration: 6,
    })
  }, [])
}
